import { IDesignStudio } from '@/components/organisms/or-design-studio-block/or-design-studio-block.types';

export const findStudioById = (
  studioId: number | null,
  allStudios: IDesignStudio[],
) => {
  if (!studioId) return null;
  // Ensure locationId is treated as a number
  if (!studioId || !allStudios) return null;

  const studio = allStudios.find((s) => {
    return s.Id === studioId;
  });

  if (studio) {
    return studio;
  }
  return null; // Return null if no matching county is found
};
